export const consentKeys = [
    'ad_storage',
    'ad_user_data',
    'ad_personalization',
    'personalization_storage',

    'analytics_storage',

    'functionality_storage',
    'security_storage'
]

export const cookieDefinitions = {
    required: {
        karrierhub: {
            title: 'Karrier Hub',
            cookies: [
                'karrierhub-access',
                'karrierhub-ui'
            ]
        }
    },
    analytics: {
        googleAnalytics: {
            title: 'Google Analytics',
            cookies: [
                '_ga',
                '_ga_*',
                '_gid'
            ]
        }
    },
    marketing: {
        googleAds: {
            title: 'Google Ads',
            cookies: [
                '_gcl_au'
            ]
        },
        meta: {
            title: 'Meta',
            cookies: [
                '_fbp'
            ]
        }
    }
}
